import "./CampaignSetup.scss";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button, Spinner, Modal } from 'react-bootstrap';
import { useFormik } from "formik";
import { Link, useParams, useHistory } from "react-router-dom";
// import * as Yup from "yup";
import { useMutation } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GET_ALL_CAMPAIGN } from '../../../gql/campaign/queries';
import { GET_CAMPAIGN_DETAILS_BY_ID } from '../../../gql/campaign/mutation';
import useUnsavedChangeWarning from '../../../hooks/useUnsavedChangeWarning';
import { GET_SETUP_DATA } from '../../../gql/campaign/setup/queries';
import { UPDATE_SETUP } from '../../../gql/campaign/setup/mutation';
import Loaders from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { UPDATE_CAMPAIGN_STATUS } from '../../../gql/campaign/mutation';
import warningIcon from '../../../assets/images/warningIcon.svg';
import playIcon from '../../../assets/images/play-icon.png';

const CampaignSetup = () => {
  const { id } = useParams()
  const history = useHistory()
  //eslint-disable-next-line
  const [isChecked, setIsChecked] = useState();
  const [repliesToAMessage, setRepliesToAMessage] = useState(false);
  const [clicksOnALink, setClicksOnALink] = useState(false);
  const [opensAnEmail, setOpensAnEmail] = useState(false);

  const [allCampaign, setAllCampaign] = useState([])
  const [clickedCampaign, setClickedCampaign] = useState({}) 
  const [setupData, setSetupData] = useState('')
  const [updatedSetupSuccess, setUpdatedSetupSuccess] = useState(false)
  const [updateSuccess, setUpdateSuccess] = useState(false)
  const [smShow2, setSmShow2] = useState(false);
  const [updatePlaySuccess, setUpdatePlaySuccess] = useState(false)
   //eslint-disable-next-line
  const [campaignStarted, setCampaignStarted] = useState(false)
  const [updatePauseSuccess, setUpdatePauseSuccess] = useState(false)
  const [campaignName, setCampaignName] = useState('')

  const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning() 
  const [errorMessage, setErrorMessage] = useState('')

  const formik = useFormik({
    initialValues: {
      checked: "",
      removeDuplicate: "",
    },
    onSubmit: (values) => {
      try {
        if (!id) {
          return toast.error('Choose Campaign First.', {
            position: "bottom-right",
            closeOnClick: true,
          })
        }
        if (!campaignName || !campaignName.trim()) {
          return toast.error("Campaign Name Is Required.", {
            position: "bottom-right",
          })
        }
        updateSetup({
          variables: {
            updateSetupInput: {
              campaignId: id,
              removeDuplicate: true,
              stopMessage: values.checked ? values.checked : setupData?.stopMessage,
              campaignName: campaignName
            }
          }
        })

      }
      catch (error) {
        console.error(error)
      }
    },
  }); 

  const [getAllCampaign] = useLazyQuery(GET_ALL_CAMPAIGN, {
    onCompleted(data) {
      setAllCampaign(data?.getAllCampaign)
    }
  })

  const [getCampaignById] = useMutation(GET_CAMPAIGN_DETAILS_BY_ID, {
    onCompleted(data) {
      if (data?.getAllSequences) {
        setClickedCampaign(data.getAllSequences)
      }
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
    fetchPolicy: 'network-only'
  })

  const [getSetupData, { loading: setupDataLoading }] = useLazyQuery(GET_SETUP_DATA, {
    onCompleted(data) {
      setCampaignName(data?.getProvidersSetupData?.campaignName)
      setSetupData(data?.getProvidersSetupData)
      setIsChecked(data?.getProvidersSetupData?.removeDuplicate)
      if (!data?.getProvidersSetupData?.stopMessage || data?.getProvidersSetupData?.stopMessage === "") {
        setRepliesToAMessage(false);
        setClicksOnALink(false);
        setOpensAnEmail(false);
      }
      if (data?.getProvidersSetupData?.stopMessage === "Replies to a message") {
        formik.values.checked = 'Replies to a message'
        setRepliesToAMessage(true);
        setClicksOnALink(false);
        setOpensAnEmail(false);
      }
      else if (data?.getProvidersSetupData?.stopMessage === "Clicks on a link") {
        formik.values.checked = 'Clicks on a link'
        setClicksOnALink(true);
        setOpensAnEmail(false);
        setRepliesToAMessage(false);
      }
      else if (data?.getProvidersSetupData?.stopMessage === "Opens an email") {
        formik.values.checked = 'Opens an email'
        setOpensAnEmail(true);
        setClicksOnALink(false);
        setRepliesToAMessage(false);
      }

    },
    fetchPolicy: 'network-only'
  })

  const [updateSetup, { loading }] = useMutation(UPDATE_SETUP, {
    onCompleted(data) {
      setUpdatedSetupSuccess(true)
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
  })

  const [updateCampaignStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
    onCompleted(data) {
      if (data?.updateCampaignStatus) {
        setUpdateSuccess(true)
      }
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
    refetchQueries: [
      'GetAllCampaign'
    ]
  })

  const [updateCampaignPlayStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
    onCompleted(data) {
      if (data?.updateCampaignStatus) {
        setClickedCampaign({
          ...clickedCampaign,
          campaignStarted : true
        })
        setUpdatePlaySuccess(true)
        setCampaignStarted(true)
      }
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
    refetchQueries: [
      'GetAllCampaign'
    ]
  })

  const [updateCampaignPauseStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
    onCompleted(data) {
      if (data?.updateCampaignStatus) {
        setClickedCampaign({
          ...clickedCampaign,
          campaignStarted : false
        })
        setUpdatePauseSuccess(true)
        setCampaignStarted(false)
      }
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
    refetchQueries: [
      'GetAllCampaign'
    ]
  })

  useEffect(() => {
    getAllCampaign()

    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (id) {
      getCampaignById({
        variables: {
          getSequenceArgs: {
            campaignId: id
          }
        }
      })
    }

    //eslint-disable-next-line
  }, [id])

  useEffect(() => {
    if (id) {
      getSetupData({
        variables: {
          providersSetupInput: {
            campaignId: id
          }
        }
      })
    }

    //eslint-disable-next-line
  }, [id])

  if (errorMessage) {
    toast.error(errorMessage, {
      position: "bottom-right",
      closeOnClick: true,
    })
    setErrorMessage('')
  }

  if (updatedSetupSuccess) {
    toast.success("Successfully Saved.", {
      position: "bottom-right",
    })
    setPristine()
    setUpdatedSetupSuccess(false)
  }

  const handleDeleteCampaign = () => {
    if (!id) {
      setSmShow2(false)
      return toast.error('Choose Campaign First.', {
        position: "bottom-right",
        closeOnClick: true,
      })
    }
    updateCampaignStatus({
      variables: {
        updateCampaignStatusInput: {
          campaignId: id,
          campaignStatus: 'DELETE'
        }
      }
    })
  }

  if (updateSuccess) {
    setSmShow2(false)
    setClickedCampaign({})
    setSetupData('')
    formik.values.checked = false
    formik.values.removeDuplicate = true;
    setRepliesToAMessage(false);
    setClicksOnALink(false);
    setOpensAnEmail(false);
    formik.resetForm()
    history.push('/campaigns/setup')
    toast.success('Campaign Deleted.', {
      position: "bottom-right",
      closeOnClick: true,
    })
    setUpdateSuccess(false) 
  }

  const handlePause = () => {
    if (!id) {
      setSmShow2(false)
      return toast.error('Choose Campaign First.', {
        position: "bottom-right",
        closeOnClick: true,
      })
    }
    updateCampaignPauseStatus({
      variables: {
        updateCampaignStatusInput: {
          campaignId: id,
          campaignStatus: 'PAUSE'
        }
      }
    })
  }

  const handlePlay = () => {
    if (!id) {
      setSmShow2(false)
      return toast.error('Choose Campaign First.', {
        position: "bottom-right",
        closeOnClick: true,
      })
    }
    updateCampaignPlayStatus({
      variables: {
        updateCampaignStatusInput: {
          campaignId: id,
          campaignStatus: 'START'
        }
      }
    })
  }

  if (updatePlaySuccess) {
    toast.success('Campaign Started.', {
      position: "bottom-right",
      closeOnClick: true,
    })
    setUpdatePlaySuccess(false)
  }

  if (updatePauseSuccess) {
    toast.success('Campaign Paused.', {
      position: "bottom-right",
      closeOnClick: true,
    })
    setUpdatePauseSuccess(false)
  }


  return (
    <>
      {/* Upper Sidebar */}
      <div className='campaign-sidebar'>
        <div className='title'>
          <h4>Campaigns</h4>
        </div>
        <div className='campaign_list_container' >
          <ul>
            {
              allCampaign && allCampaign.length > 0 && allCampaign.map((item, i) => {
                if (item?.campaignStatus !== 'delete' && (item?.campaignType === 'autoScript' && item?.sequence.length > 0) ) {
                  return <li key={item?._id} style={{ backgroundColor: item?._id === id ? '#F5F7FB' : '#FFFFFF' }}  >
                    <Link to={`/campaigns/setup/${item?._id}`}
                      onClick={() => {
                        setPristine()
                        setClickedCampaign(item)
                      }}
                    >
                      {item?.campaignName}
                    </Link>
                  </li>
                }
                else if (item?.campaignStatus !== 'delete' && (item?.campaignType === 'manualScript') ) {
                  return <li key={item?._id} style={{ backgroundColor: item?._id === id ? '#F5F7FB' : '#FFFFFF' }}  >
                    <Link to={`/campaigns/setup/${item?._id}`}
                      onClick={() => {
                        setPristine()
                        setClickedCampaign(item)
                      }}
                    >
                      {item?.campaignName}
                    </Link>
                  </li>
                }
                return false
              })
            }
          </ul>
        </div>
        <div className='create-camp-btn'>
          <button className='solid-button'
            onClick={() => {
              setIsDirty()
              history.push('/campaign-name')
            }}
          >
            Create New Campaigns
          </button>
        </div>
      </div>

      <div className='campaign-details'>
        <div className='title-btn-container'>
          <h1>{clickedCampaign?.campaignName}</h1>
          <div className='btn-container'>
            <button className='play-pause-btn'>
              {
                // clickedCampaign?.campaignStarted === true || campaignStarted === true ?
                clickedCampaign?.campaignStarted === true ?
                  <span className='pause' onClick={handlePause} >
                    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.5 1H1V15H4.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M11.5 1H8V15H11.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Pause
                  </span>
                  :
                  <span className='play' onClick={handlePlay} >
                    {/* <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.5 1H1V15H4.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M11.5 1H8V15H11.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg> */}
                    <img src={playIcon} alt="play" width="20" height="20" />
                    Play
                  </span>

              }
            </button>
            {
              loading ?
                <button className='solid-button' >Save &nbsp;
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                </button>
                :
                <label htmlFor="submit-form_setup" className='solid_button_save_schedule' >Save</label>

            }
            {/* <label htmlFor="submit-form_setup" className='solid_button_save_schedule' >Save</label> */}
            <button className='delete-btn' onClick={() => setSmShow2(true)}  >
              <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.998047 4.40332H2.86471H17.798" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.66719 4.39935V2.53268C5.66719 2.03761 5.86385 1.56282 6.21392 1.21275C6.56399 0.862682 7.03878 0.666016 7.53385 0.666016H11.2672C11.7623 0.666016 12.2371 0.862682 12.5871 1.21275C12.9372 1.56282 13.1339 2.03761 13.1339 2.53268V4.39935M15.9339 4.39935V17.466C15.9339 17.9611 15.7372 18.4359 15.3871 18.7859C15.0371 19.136 14.5623 19.3327 14.0672 19.3327H4.73385C4.23878 19.3327 3.76399 19.136 3.41392 18.7859C3.06385 18.4359 2.86719 17.9611 2.86719 17.466V4.39935H15.9339Z" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        <ul className='campaign-detail-tabs'>
          <li className="tab_sequence" >
            <Link to={id ? `/campaigns/leads/${id}` : '/campaigns/leads'} >Leads</Link>
          </li>
          <li className="tab_sequence" >
            <Link to={id ? `/campaigns/campaign-details/${id}` : '/campaigns/campaign-details'}>Sequence</Link>
          </li>
          <li className="tab_sequence" >
            <Link to={id ? `/campaigns/schedule/${id}` : '/campaigns/schedule'} >Schedules</Link>
          </li>
          <li className='active' >
            <Link to='#'>Setup</Link>
          </li>
        </ul>
        {/* Upper Sidebar */}

        {/* Changed Code */}
        <div className="sequence-content">
          <div className="sequence-type">
            <h4>Campaign Setup</h4>
            {
              setupDataLoading ?
                <div className="spinner" >
                  <Loaders
                    type="ThreeDots"
                    color="#192f60"
                    height={70}
                    width={70}
                    timeout={3000}
                  />
                </div>
                :

                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="mb-3" controlId="name">
                    <Form.Label> Campaign Name</Form.Label>
                    <Form.Control
                      name="campaignName"
                      type="text"
                      placeholder=""
                      // value={formik.values.campaignName}
                      // onChange={formik.handleChange}
                      // onInput={() => setIsDirty()}
                      // value={setupData?.campaignName ? setupData?.campaignName : ""}
                      value={campaignName}
                      onChange={(e) => setCampaignName(e.target.value)}
                      className={`${formik.errors.campaignName && formik.touched.campaignName && "border-danger"}`}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email Address use to send emails</Form.Label>
                    <Form.Control
                      type="text"
                      name="campaignEmail"
                      placeholder=""
                      value={setupData?.senderEmail ? `${setupData?.senderName} <${setupData?.senderEmail}>` : ""}
                      readOnly
                      className={`${formik.errors.campaignEmail && formik.touched.campaignEmail && "border-danger"}`}
                      style={{ cursor: 'not-allowed' }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="phn">
                    <Form.Label>Phone Number use to send sms</Form.Label>
                    <Form.Control
                      type="text"
                      name="campaignPhone"
                      placeholder=""
                      value={setupData?.senderNumber ? setupData?.senderNumber : ""}
                      readOnly
                      className={`${formik.errors.campaignPhone && formik.touched.campaignPhone && "border-danger"}`}
                      style={{ cursor: 'not-allowed' }}
                    />
                  </Form.Group>
                  <Row>
                    <Col>
                      <h4>Stop sending messages when your lead</h4>
                      <Form.Check
                        type="checkbox"
                        id="Replies to a message"
                        label="Replies to a message (email)"
                        value="Replies to a message"
                        checked={repliesToAMessage}
                        onChange={(e) => {
                          if(e.target.checked){
                            formik.values.checked = e.target.value; 
                          }
                          else if(!e.target.checked){
                            formik.values.checked = ""

                          }
                          // setRepliesToAMessage(true);
                          setRepliesToAMessage(!repliesToAMessage);
                          setClicksOnALink(false);
                          setOpensAnEmail(false);
                          setIsDirty()
                        }}
                      />
                      <Form.Check
                        type="checkbox"
                        id="Clicks on a link"
                        label="Clicks on a link (email)"
                        value="Clicks on a link"
                        checked={clicksOnALink}
                        onChange={(e) => {
                          if(e.target.checked){
                            formik.values.checked = e.target.value;
                          }
                          else if(!e.target.checked){
                            formik.values.checked = ""

                          }
                          // setClicksOnALink(true);
                          setClicksOnALink(!clicksOnALink);
                          setOpensAnEmail(false);
                          setRepliesToAMessage(false);
                          setIsDirty()
                        }}
                      />
                      <Form.Check
                        type="checkbox"
                        id="Opens an email"
                        label="Opens an email"
                        value="Opens an email"
                        checked={opensAnEmail}
                        onChange={(e) => {
                          if(e.target.checked){
                            formik.values.checked = e.target.value;
                          }
                          else if(!e.target.checked){
                            formik.values.checked = ""

                          }
                          // setOpensAnEmail(true);
                          setOpensAnEmail(!opensAnEmail);
                          setClicksOnALink(false);
                          setRepliesToAMessage(false);
                          setIsDirty()
                        }}
                      />
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-end">
                    {" "}
                    <Button className='solid-button setup_save_btn' id="submit-form_setup" type="submit" style={{ display: 'none' }}>Save</Button>
                  </div>
                </Form>
            }
          </div>
        </div>
        {/* Changed Code */}

      </div>

      <Modal
        size="md"
        className='warning-modal'
        show={smShow2}
        onHide={() => setSmShow2(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className='warning-div'>
            <img src={warningIcon} alt="warning" />
            <h2>Warning</h2>
            <p>Are you sure you want to delete this campaign?
            </p>
            <div className='btn-container'>
              <button className='cancel-btn' onClick={() => setSmShow2(false)}>No</button>
              <button className='solid-button' style={{ flex: "0 0 128px" }} onClick={handleDeleteCampaign} >
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {Prompt}
    </>
  );

};
export default CampaignSetup;
